import gql from 'graphql-tag';

export const CREATE_ACTIVITY = gql`
  mutation createActivity(
    $photo: Upload!
    $activity: ActivityInput
    $businessOwnerId: Int
    $addOns: [AddOnInput]
    $deactivationPeriods: [DeactivationPeriodsInput]
  ) {
    createActivity(
      photo: $photo
      activity: $activity
      addOns: $addOns
      businessOwnerId: $businessOwnerId
      deactivationPeriods: $deactivationPeriods
    ) {
      id
    }
  }
`;

export const DELETE_ACTIVITY = gql`
  mutation deleteActivity($id: Int!) {
    deleteActivity(id: $id) {
      id
    }
  }
`;

export const UPDATE_ACTIVITY = gql`
  mutation updateActivity(
    $photo: Upload
    $businessOwnerId: Int
    $activity: ActivityInput
    $addOns: [AddOnInput]
    $deletedAddOns: [Int]
    $deletedRelatedAccommodation: [Int]
    $deletedPlatforms: [Int]
    $deactivationPeriods: [DeactivationPeriodsInput]
  ) {
    updateActivity(
      photo: $photo
      businessOwnerId: $businessOwnerId
      activity: $activity
      addOns: $addOns
      deletedAddOns: $deletedAddOns
      deletedRelatedAccommodation: $deletedRelatedAccommodation
      deletedPlatforms: $deletedPlatforms
      deactivationPeriods: $deactivationPeriods
    ) {
      activity {
        id
      }
    }
  }
`;

export const CREATE_ACTIVITY_RATE_PLAN = gql`
  mutation CreateActivityRatePlan($ratePlan: [ActivityRatePlanInput!]!) {
    createActivityRatePlan(ratePlan: $ratePlan) {
      ratePlan {
        id
        title
      }
    }
  }
`;

export const DELETE_ACTIVITY_RATE_PLAN = gql`
  mutation DeleteActivityRatePlan($id: ID!, $businessOwnerId: ID) {
    deleteActivityRatePlan(id: $id, businessOwnerId: $businessOwnerId) {
      success
      message
    }
  }
`;

